import { Route, Routes } from "react-router-dom";
import Main from "./pages/Main";
import ImagePreloader from "./ImagePreloader";

function App() {
  const imagesToPreload = [
    "group_227.jpg",
    "mask_group_1.png",
  ];

  return (
    <div className="App">
      <ImagePreloader images={imagesToPreload} />
      <Routes>
        <Route exact path="/" element={<Main />} />
      </Routes>
    </div>
  );
}

export default App;
